import React from 'react'
import {
  RiAddLine,
  RiAdminLine,
  RiAlertLine,
  RiArrowDownLine,
  RiArrowDownSLine,
  RiArrowGoBackLine,
  RiArrowRightLine,
  RiArrowRightSLine,
  RiArrowUpSLine,
  RiArrowUpLine,
  RiAttachment2,
  RiBarChart2Line,
  RiBookOpenLine,
  RiBrainLine,
  RiBriefcaseLine,
  RiBugLine,
  RiCalendarScheduleLine,
  RiCameraLine,
  RiChatNewLine,
  RiCheckLine,
  RiCheckboxBlankLine,
  RiCheckboxLine,
  RiCheckboxMultipleLine,
  RiClipboardLine,
  RiCloseLine,
  RiCodeBoxLine,
  RiCodeSSlashLine,
  RiCornerUpRightLine,
  RiComputerLine,
  RiCpuLine,
  RiDatabase2Line,
  RiDeleteBin2Line,
  RiDeleteBinLine,
  RiDownloadLine,
  RiEdit2Line,
  RiErrorWarningLine,
  RiExpandUpDownLine,
  RiExternalLinkLine,
  RiEyeLine,
  RiEyeOffLine,
  RiFile3Line,
  RiFileAddLine,
  RiFileCodeLine,
  RiFileList2Line,
  RiFileCopyLine,
  RiFileMusicLine,
  RiFileTextLine,
  RiFileVideoLine,
  RiFlaskLine,
  RiFolder3Line,
  RiFolderAddLine,
  RiFolderOpenLine,
  RiFolderLine,
  RiFolderReceivedLine,
  RiFullscreenLine,
  RiFullscreenExitLine,
  RiGamepadLine,
  RiGitBranchLine,
  RiGitCommitLine,
  RiGitRepositoryLine,
  RiGlobalLine,
  RiHeartLine,
  RiHomeLine,
  RiInboxLine,
  RiImageLine,
  RiInformationLine,
  RiKey2Line,
  RiLayoutLeftLine,
  RiLayoutMasonryLine,
  RiLayoutRightLine,
  RiLeafLine,
  RiLightbulbLine,
  RiLink,
  RiLinksLine,
  RiLineChartLine,
  RiLoader2Line,
  RiLogoutBoxLine,
  RiMenuLine,
  RiMoonLine,
  RiMore2Line,
  RiMusicLine,
  RiNewspaperLine,
  RiNotification3Line,
  RiPaletteLine,
  RiPencilLine,
  RiPlugLine,
  RiPushpinLine,
  RiQuestionLine,
  RiRefreshLine,
  RiRobot2Line,
  RiRobot3Line,
  RiRocketLine,
  RiSaveLine,
  RiSearchEyeLine,
  RiSearchLine,
  RiSendPlaneLine,
  RiServerLine,
  RiSettingsLine,
  RiSettings3Line,
  RiShieldCheckLine,
  RiShieldKeyholeLine,
  RiShieldLine,
  RiSmartphoneLine,
  RiStarFill,
  RiStarLine,
  RiStopLine,
  RiSubtractLine,
  RiSunLine,
  RiTaskLine,
  RiTerminalBoxLine,
  RiTestTubeLine,
  RiTimeLine,
  RiTodoLine,
  RiToolsLine,
  RiUploadLine,
  RiUserSmileLine,
  RiUser3Line,
  RiZoomInLine,
  RiZoomOutLine,
} from '@remixicon/react'

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties; size?: number | string; [key: string]: unknown }>> = {
  'add': RiAddLine,
  'admin': RiAdminLine,
  'alert': RiAlertLine,
  'alert-triangle': RiErrorWarningLine,
  'arrow-down': RiArrowDownLine,
  'arrow-down-s': RiArrowDownSLine,
  'arrow-go-back': RiArrowGoBackLine,
  'arrow-right': RiArrowRightLine,
  'arrow-right-s': RiArrowRightSLine,
  'arrow-up-s': RiArrowUpSLine,
  'arrow-up': RiArrowUpLine,
  'attachment-2': RiAttachment2,
  'bar-chart-2': RiBarChart2Line,
  'book-open': RiBookOpenLine,
  'brain': RiBrainLine,
  'briefcase': RiBriefcaseLine,
  'bug': RiBugLine,
  'calendar-schedule': RiCalendarScheduleLine,
  'camera': RiCameraLine,
  'chat-new': RiChatNewLine,
  'chart-line': RiLineChartLine,
  'check': RiCheckLine,
  'checkbox': RiCheckboxLine,
  'checkbox-blank': RiCheckboxBlankLine,
  'checkbox-multiple': RiCheckboxMultipleLine,
  'clipboard': RiClipboardLine,
  'close': RiCloseLine,
  'code-box': RiCodeBoxLine,
  'code-s-slash': RiCodeSSlashLine,
  'computer': RiComputerLine,
  'corner-up-right': RiCornerUpRightLine,
  'cpu': RiCpuLine,
  'database-2': RiDatabase2Line,
  'delete-bin': RiDeleteBinLine,
  'download': RiDownloadLine,
  'edit-2': RiEdit2Line,
  'error-warning': RiErrorWarningLine,
  'expand-up-down': RiExpandUpDownLine,
  'eye': RiEyeLine,
  'eye-off': RiEyeOffLine,
  'file-3': RiFile3Line,
  'file-add': RiFileAddLine,
  'file-code': RiFileCodeLine,
  'file-copy': RiFileCopyLine,
  'file-list': RiFileList2Line,
  'file-music': RiFileMusicLine,
  'file-text': RiFileTextLine,
  'file-video': RiFileVideoLine,
  'flask': RiFlaskLine,
  'folder': RiFolderLine,
  'folder-3': RiFolder3Line,
  'folder-add': RiFolderAddLine,
  'folder-open': RiFolderOpenLine,
  'folder-received': RiFolderReceivedLine,
  'fullscreen': RiFullscreenLine,
  'fullscreen-exit': RiFullscreenExitLine,
  'gamepad': RiGamepadLine,
  'git-branch': RiGitBranchLine,
  'git-commit': RiGitCommitLine,
  'git-repository': RiGitRepositoryLine,
  'global': RiGlobalLine,
  'heart': RiHeartLine,
  'home': RiHomeLine,
  'image': RiImageLine,
  'inbox': RiInboxLine,
  'information': RiInformationLine,
  'key': RiKey2Line,
  'layout-left': RiLayoutLeftLine,
  'layout-masonry': RiLayoutMasonryLine,
  'layout-right': RiLayoutRightLine,
  'leaf': RiLeafLine,
  'lightbulb': RiLightbulbLine,
  'line-chart': RiLineChartLine,
  'link': RiLink,
  'links-line': RiLinksLine,
  'external-link': RiExternalLinkLine,
  'loader-2': RiLoader2Line,
  'logout': RiLogoutBoxLine,
  'menu': RiMenuLine,
  'moon': RiMoonLine,
  'more-2': RiMore2Line,
  'music': RiMusicLine,
  'newspaper': RiNewspaperLine,
  'notification-3': RiNotification3Line,
  'palette': RiPaletteLine,
  'pencil': RiPencilLine,
  'pencil-ai': RiPencilLine,
  'plug': RiPlugLine,
  'pushpin': RiPushpinLine,
  'question': RiQuestionLine,
  'refresh': RiRefreshLine,
  'robot-2': RiRobot2Line,
  'robot-3': RiRobot3Line,
  'rocket': RiRocketLine,
  'save': RiSaveLine,
  'search': RiSearchLine,
  'search-eye': RiSearchEyeLine,
  'send-plane': RiSendPlaneLine,
  'server': RiServerLine,
  'settings': RiSettingsLine,
  'settings-3': RiSettings3Line,
  'shield': RiShieldLine,
  'shield-check': RiShieldCheckLine,
  'shield-keyhole': RiShieldKeyholeLine,
  'smartphone': RiSmartphoneLine,
  'star': RiStarLine,
  'star-fill': RiStarFill,
  'stop': RiStopLine,
  'subtract': RiSubtractLine,
  'sun': RiSunLine,
  'task': RiTaskLine,
  'terminal-box': RiTerminalBoxLine,
  'test-tube': RiTestTubeLine,
  'time': RiTimeLine,
  'todo': RiTodoLine,
  'tools': RiToolsLine,
  'trash-2': RiDeleteBin2Line,
  'upload': RiUploadLine,
  'user-3': RiUser3Line,
  'user-smile': RiUserSmileLine,
  'x': RiCloseLine,
  'zoom-in': RiZoomInLine,
  'zoom-out': RiZoomOutLine,
}

export type IconName = keyof typeof iconMap

export interface IconProps extends React.ComponentPropsWithoutRef<'svg'> {
  name: IconName
}

/** Проверка, что строка — валидное имя иконки из реестра (без `as never`). */
export function isIconName(name: string | null | undefined): name is IconName {
  return typeof name === 'string' && name in iconMap
}

export const Icon = React.memo(({ name, ...rest }: IconProps) => {
  const Component = iconMap[name]
  if (!Component) return null
  return <Component {...rest} />
})

Icon.displayName = 'Icon'
